import { defineMessages } from 'react-intl';
export default defineMessages({
  fullypaid: {
    id: 'fullypaid',
    defaultMessage: 'Paid'
  },
  billed: {
    id: 'billed',
    defaultMessage: 'Scheduled'
  },
  planned: {
    id: 'planned',
    defaultMessage: 'Scheduled'
  },
  due: {
    id: 'due',
    defaultMessage: 'Overdue'
  }
});